import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientInsuranceInfoNoteModalTemplate } from 'themes/application/niko-patient/components';
import { NikoPatientInsuranceInfoNoteModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoPatientInsuranceInfoNoteModalStore(rootStore, componentProps), 'nikoPatientInsuranceInfoNoteModalStore')
@observer
class NikoPatientInsuranceInfoNoteModal extends React.Component {
    render() {
        return <NikoPatientInsuranceInfoNoteModalTemplate {...this.props} />
    }
}

export default NikoPatientInsuranceInfoNoteModal;